import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Germplasm } from '../entities/germplasm/germplasm.model';
import { GermplasmSearchRequest } from '../entities/germplasm/germplasm-search-request.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnFilterComponent, FilterType } from '../shared/column-filter/column-filter.component';
import { GermplasmService } from '../shared/germplasm/service/germplasm.service';
import { finalize } from 'rxjs/internal/operators/finalize';
import { HttpResponse } from '@angular/common/http';
import { JhiEventManager, JhiLanguageService } from '../shared/core-utils';
import { NgbActiveModal, NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { GermplasmTreeTableComponent } from '../shared/tree/germplasm/germplasm-tree-table.component';
import { StudyTreeComponent } from '../shared/tree/study/study-tree.component';
import { MatchType } from '../shared/column-filter/column-filter-text-with-match-options-component';
import { PedigreeType } from '../shared/column-filter/column-filter-pedigree-options-component';
import { SORT_PREDICATE_NONE } from './germplasm-search-resolve-paging-params';
import { PopupService } from '../shared/modal/popup.service';
import { ModalConfirmComponent } from '../shared/modal/modal-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { GermplasmManagerContext } from './germplasm-manager.context';
import { SearchComposite } from '../shared/model/search-composite';
import {
    ADD_GERMPLASM_ENTRIES_TO_LIST_PERMISSIONS,
    CODE_GERMPLASM_PERMISSIONS,
    CREATE_INVENTORY_LOT_PERMISSIONS,
    DELETE_GERMPLASM_PERMISSIONS,
    GERMPLASM_LABEL_PRINTING_PERMISSIONS,
    GROUP_GERMPLASM_PERMISSIONS,
    IMPORT_GERMPLASM_PERMISSIONS,
    IMPORT_GERMPLASM_UPDATES_PERMISSIONS,
    MANAGE_GERMPLASM_PERMISSIONS,
    MERGE_GERMPLASM_PERMISSIONS,
    UNGROUP_GERMPLASM_PERMISSIONS,
    VIEW_NAMES_PERMISSION,
    VIEW_PEDIGREE_INFORMATION_PERMISSION
} from '../shared/auth/permissions';
import { AlertService } from '../shared/alert/alert.service';
import { ListBuilderContext } from '../shared/list-builder/list-builder.context';
import { ListEntry } from '../shared/list-builder/model/list.model';
import { KeySequenceRegisterDeletionDialogComponent } from './key-sequence-register/key-sequence-register-deletion-dialog.component';
import { MAX_NAME_DISPLAY_SIZE } from '../app.constants';
import { ParamContext } from '../shared/service/param.context';
import { SearchResult } from '../shared/search-result.model';
import { GermplasmGroupOptionsDialogComponent } from './grouping/germplasm-group-options-dialog-component';
import { GermplasmGroupingService } from '../shared/germplasm/service/germplasm-grouping.service';
import { GermplasmGroupingResultComponent } from './grouping/germplasm-grouping-result.component';
import { GermplasmCodingDialogComponent } from './coding/germplasm-coding-dialog.component';
import { GermplasmCodingResultDialogComponent } from './coding/germplasm-coding-result-dialog.component';
import { GermplasmCodeNameBatchResultModel } from '../shared/germplasm/model/germplasm-code-name-batch-result.model';
import { SearchOrigin, SearchOriginComposite } from '../shared/model/Search-origin-composite';
import { MergeGermplasmSelectionComponent } from './merge/merge-germplasm-selection-component';
import { Principal } from '../shared';
import { GermplasmColumnModel } from './column-visibility/germplasm-columns.component';
import { GermplasmDetailsPopupService } from '../germplasm-details/germplasm-details-popup.service';
import { InventoryDetailsPopupService } from './inventory/details/inventory-details-popup.service';
import { LabelPrintingType } from '../label-printing/label-printing.component';
import { LabelPrintingService } from '../label-printing/label-printing.service';
import { GermplasmListManagerContext } from '../germplasm-list/germplasm-list-manager.context';
import { SubscriptionsManager } from '../shared/util/subscriptions-manager';
import { preventDefaultOnShiftKey } from '../field-management/utils';

@Component({
    selector: 'jhi-germplasm-search',
    templateUrl: './germplasm-search.component.html'
})
export class GermplasmSearchComponent implements OnInit, OnDestroy {

    IMPORT_GERMPLASM_PERMISSIONS = IMPORT_GERMPLASM_PERMISSIONS;
    // TODO The Permissions will be change after implement IBP-4570 (New list manager)
    CREATE_GERMPLASM_LIST_PERMISSIONS = [...MANAGE_GERMPLASM_PERMISSIONS, 'CREATE_LIST'];
    ADD_GERMPLASM_ENTRIES_TO_LIST_PERMISSIONS = ADD_GERMPLASM_ENTRIES_TO_LIST_PERMISSIONS;
    IMPORT_GERMPLASM_UPDATES_PERMISSIONS = IMPORT_GERMPLASM_UPDATES_PERMISSIONS;
    GERMPLASM_LABEL_PRINTING_PERMISSIONS = GERMPLASM_LABEL_PRINTING_PERMISSIONS;
    DELETE_GERMPLASM_PERMISSIONS = DELETE_GERMPLASM_PERMISSIONS;
    MERGE_GERMPLASM_PERMISSIONS = MERGE_GERMPLASM_PERMISSIONS;
    GROUP_GERMPLASM_PERMISSIONS = GROUP_GERMPLASM_PERMISSIONS;
    UNGROUP_GERMPLASM_PERMISSIONS = UNGROUP_GERMPLASM_PERMISSIONS;
    CODE_GERMPLASM_PERMISSIONS = CODE_GERMPLASM_PERMISSIONS;
    CREATE_INVENTORY_LOT_PERMISSIONS = CREATE_INVENTORY_LOT_PERMISSIONS;
    VIEW_PEDIGREE_INFORMATION_PERMISSION = VIEW_PEDIGREE_INFORMATION_PERMISSION;
    VIEW_NAMES_PERMISSION = VIEW_NAMES_PERMISSION;

    MAX_NAME_DISPLAY_SIZE = MAX_NAME_DISPLAY_SIZE;
    SELECT_BROWSE_ALL_RESULTS_MAX_SIZE = 15000;
    GERMPLASM_MERGE_MAX_SIZE = 100;

    ColumnLabels = ColumnLabels;

    @ViewChild('colVisPopOver', { static: true }) public colVisPopOver: NgbPopover;

    subscriptionsManager = new SubscriptionsManager();
    germplasmList: Germplasm[];
    error: any;
    currentSearch: string;
    routeData: any;
    links: any;
    filteredItems: any;
    itemsPerPage: any = 20;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: boolean;
    resultSearch: SearchResult;

    isLoading: boolean;

    germplasmSearchRequest = new GermplasmSearchRequest();
    germplasmFilters: any;
    germplasmHiddenColumns = {};

    // { <gid>: germplasm }
    selectedItems: { [key: number]: Germplasm } = {};
    isSelectAll = false;
    isBrowseAllResults = false;
    lastClickIndex: any;

    NAMES_RELATED_FILTERS = ['nameFilter', 'femaleParentName', 'maleParentName', 'groupSourceName', 'immediateSourceName', 'nameTypes'];
    PEDIGREE_RELATED_FILTERS = ['femaleParentName', 'maleParentName', 'groupSourceName', 'immediateSourceName', 'includePedigree'];

    additionalColumns = ['PREFERRED ID', 'PREFERRED NAME', 'GERMPLASM DATE',
        'METHOD ABBREV', 'METHOD NUMBER', 'METHOD GROUP',
        'FGID', 'MGID', 'CROSS-FEMALE PREFERRED NAME', 'CROSS-MALE PREFERRED NAME',
        'GROUP SOURCE GID', 'GROUP SOURCE', 'IMMEDIATE SOURCE GID', 'IMMEDIATE SOURCE'];

    private static getInitialFilters() {
        return [
            {
                key: 'nameFilter', name: 'column-filter.name', placeholder: 'column-filter.search.text.placeholder', type: FilterType.TEXT_WITH_MATCH_OPTIONS,
                matchType: MatchType.STARTSWITH, default: true
            },
            { key: 'germplasmUUID', name: 'column-filter.germplasm.uuid', placeholder: 'column-filter.match.text.placeholder', type: FilterType.TEXT },
            { key: 'gids', name: 'column-filter.gid', placeholder: 'column-filter.comma.separated.values.placeholder', type: FilterType.LIST, default: true },
            {
                key: 'gidRange', name: 'column-filter.gid.range', type: FilterType.NUMBER_RANGE,
                fromKey: 'gidFrom',
                toKey: 'gidTo',
                transform(req) {
                    ColumnFilterComponent.transformNumberRangeFilter(this, req, this.fromKey, this.toKey);
                },
                reset(req) {
                    ColumnFilterComponent.resetRangeFilter(this, req, this.fromKey, this.toKey);
                },
                reload(req) {
                    this.from = req[this.fromKey];
                    this.to = req[this.toKey];
                }
            },
            { key: 'groupId', name: 'column-filter.group.id', placeholder: 'column-filter.match.text.placeholder', type: FilterType.TEXT },
            { key: 'sampleUID', name: 'column-filter.sample.id', placeholder: 'column-filter.match.text.placeholder', type: FilterType.TEXT },
            {
                key: 'germplasmListIds', name: 'column-filter.germplasm.list', type: FilterType.MODAL,
                open(modal, request) {
                    return new Promise((resolve) => {
                        modal.open(GermplasmTreeTableComponent as Component, { size: 'xl', backdrop: 'static' })
                            .result.then((germplasmLists) => {
                                if (germplasmLists && germplasmLists.length > 0) {
                                    this.value = germplasmLists.map((list) => list.name);
                                    request[this.key] = germplasmLists.map((list) => list.id);
                                }
                                resolve(undefined);
                            }, () => {
                            });
                    });
                }
            },
            { key: 'stockId', name: 'column-filter.stock.id', placeholder: 'column-filter.starts.with.placeholder', type: FilterType.TEXT },
            { key: 'locationOfOrigin', name: 'column-filter.location.of.origin', placeholder: 'column-filter.contains.text.placeholder', type: FilterType.TEXT },
            { key: 'locationOfUse', name: 'column-filter.location.of.use', placeholder: 'column-filter.contains.text.placeholder', type: FilterType.TEXT },
            {
                key: 'studyOfUseIds', name: 'column-filter.study.of.use', type: FilterType.MODAL,
                open(modal, request) {
                    return new Promise((resolve) => {
                        modal.open(StudyTreeComponent as Component, { modalDialogClass: 'modal-xs', backdrop: 'static' })
                            .result.then((studyIds) => {
                                if (studyIds) {
                                    this.value = studyIds.map((list) => list.name);
                                    request[this.key] = studyIds.map((list) => list.id);
                                }
                                resolve(undefined);
                            }, () => {
                            });
                    });
                }
            },
            {
                key: 'studyOfOriginIds', name: 'column-filter.study.of.origin', type: FilterType.MODAL,
                open(modal, request) {
                    return new Promise((resolve) => {
                        modal.open(StudyTreeComponent as Component, { modalDialogClass: 'modal-xs', backdrop: 'static' })
                            .result.then((studyIds) => {
                                if (studyIds) {
                                    this.value = studyIds.map((list) => list.name);
                                    request[this.key] = studyIds.map((list) => list.id);
                                }
                                resolve(undefined);
                            }, () => {
                            });
                    });
                }
            },
            {
                key: 'plantingStudyIds', name: 'column-filter.study.of.lot.use', type: FilterType.MODAL,
                open(modal, request) {
                    return new Promise((resolve) => {
                        modal.open(StudyTreeComponent as Component, { modalDialogClass: 'modal-xs', backdrop: 'static' })
                            .result.then((studyIds) => {
                                if (studyIds) {
                                    this.value = studyIds.map((list) => list.name);
                                    request[this.key] = studyIds.map((list) => list.id);
                                }
                                resolve(undefined);
                            }, () => {
                            });
                    });
                }
            },
            {
                key: 'harvestingStudyIds', name: 'column-filter.study.of.lot.origin', type: FilterType.MODAL,
                open(modal, request) {
                    return new Promise((resolve) => {
                        modal.open(StudyTreeComponent as Component, { modalDialogClass: 'modal-xs', backdrop: 'static' })
                            .result.then((studyIds) => {
                                if (studyIds) {
                                    this.value = studyIds.map((list) => list.name);
                                    request[this.key] = studyIds.map((list) => list.id);
                                }
                                resolve(undefined);
                            }, () => {
                            });
                    });
                }
            },
            { key: 'reference', name: 'column-filter.reference', placeholder: 'column-filter.contains.text.placeholder', type: FilterType.TEXT },
            { key: 'breedingMethodName', name: 'column-filter.breeding.method.name', placeholder: 'column-filter.contains.text.placeholder', type: FilterType.TEXT },
            {
                key: 'germplasmDate', name: 'column-filter.germplasm.date', type: FilterType.DATE,
                fromKey: 'germplasmDateFrom',
                toKey: 'germplasmDateTo',
                transform(req) {
                    ColumnFilterComponent.transformDateFilter(this, req, this.fromKey, this.toKey);
                },
                reset(req) {
                    ColumnFilterComponent.resetRangeFilter(this, req, this.fromKey, this.toKey);
                },
                reload(req) {
                    this.from = req[this.fromKey];
                    this.to = req[this.toKey];
                }
            },
            {
                key: 'femaleParentName', name: 'column-filter.cross.female.parent.name', placeholder: 'column-filter.search.text.placeholder', type: FilterType.TEXT_WITH_MATCH_OPTIONS,
                matchType: MatchType.STARTSWITH
            },
            {
                key: 'maleParentName', name: 'column-filter.cross.male.parent.name', placeholder: 'column-filter.search.text.placeholder', type: FilterType.TEXT_WITH_MATCH_OPTIONS,
                matchType: MatchType.STARTSWITH
            },
            {
                key: 'groupSourceName', name: 'column-filter.group.source.name', placeholder: 'column-filter.contains.text.placeholder', type: FilterType.TEXT_WITH_MATCH_OPTIONS,
                matchType: MatchType.STARTSWITH
            },
            {
                key: 'immediateSourceName', name: 'column-filter.immediate.source.name', placeholder: 'column-filter.contains.text.placeholder', type: FilterType.TEXT_WITH_MATCH_OPTIONS,
                matchType: MatchType.STARTSWITH
            },
            { key: 'withInventoryOnly', name: 'column-filter.with.inventory.only', type: FilterType.BOOLEAN, value: true },
            { key: 'withRawObservationsOnly', name: 'column-filter.with.observations.only', type: FilterType.BOOLEAN, value: true },
            { key: 'withSampleOnly', name: 'column-filter.with.sample.only', type: FilterType.BOOLEAN, value: true },
            { key: 'withAnalyzedDataOnly', name: 'column-filter.with.analyzed.data.only', type: FilterType.BOOLEAN, value: true },
            { key: 'inProgramListOnly', name: 'column-filter.in.program.list.only', type: FilterType.BOOLEAN, value: true },
            { key: 'includeGroupMembers', name: 'column-filter.include.group.members', type: FilterType.BOOLEAN, value: true },
            {
                key: 'includePedigree', name: 'column-filter.include.pedigree', type: FilterType.PEDIGREE_OPTIONS,
                pedigreeType: PedigreeType.GENERATIVE,
                value: 1, // Generation Level
                transform(req) {
                    ColumnFilterComponent.transformPedigreeOptionsFilter(this, req);
                },
                options: Promise.resolve([{
                    id: PedigreeType.GENERATIVE, name: 'column-filter.pedigree.option.generative'
                }, {
                    id: PedigreeType.DERIVATIVE, name: 'column-filter.pedigree.option.derivative'
                }, {
                    id: PedigreeType.BOTH, name: 'column-filter.pedigree.option.both'
                }])
            },
            {
                key: 'attributes', name: 'column-filter.attributes', placeholder: 'column-filter.attributes.placeholder', type: FilterType.ATTRIBUTES, attributes: [],
                transform(req) {
                    ColumnFilterComponent.transformAttributesFilter(this, req);
                },
                reset(req) {
                    ColumnFilterComponent.resetAttributesFilter(this, req);
                },
            },
            {
                key: 'nameTypes', name: 'column-filter.name.types', placeholder: 'column-filter.name.types.placeholder', type: FilterType.NAME_TYPES, nameTypes: [],
                transform(req) {
                    ColumnFilterComponent.transformNameTypesFilter(this, req);
                },
                reset(req) {
                    ColumnFilterComponent.resetNameTypesFilter(this, req);
                },
            },
            {
                key: 'externalReferenceSource', name: 'column-filter.external.reference.source', placeholder: 'column-filter.search.text.placeholder', type: FilterType.TEXT_WITH_MATCH_OPTIONS,
                matchType: MatchType.STARTSWITH
            },
            {
                key: 'externalReferenceId', name: 'column-filter.external.reference.id', placeholder: 'column-filter.search.text.placeholder', type: FilterType.TEXT_WITH_MATCH_OPTIONS,
                matchType: MatchType.STARTSWITH
            }
        ];
    }

    get request() {
        return this.germplasmSearchRequest;
    }

    set request(request) {
        this.germplasmSearchRequest = request;
    }

    get filters() {
        return this.germplasmFilters;
    }

    set filters(filters) {
        this.germplasmFilters = filters;
    }

    get hiddenColumns() {
        return this.germplasmHiddenColumns;
    }

    set hiddenColumns(hiddenColumns) {
        this.germplasmHiddenColumns = hiddenColumns;
    }

    constructor(private activatedRoute: ActivatedRoute,
                private jhiLanguageService: JhiLanguageService,
                private eventManager: JhiEventManager,
                private germplasmService: GermplasmService,
                private germplasmGroupingService: GermplasmGroupingService,
                private router: Router,
                private alertService: AlertService,
                private translateService: TranslateService,
                private popupService: PopupService,
                private germplasmManagerContext: GermplasmManagerContext,
                private modalService: NgbModal,
                private activeModal: NgbActiveModal,
                public listBuilderContext: ListBuilderContext,
                private paramContext: ParamContext,
                private principal: Principal,
                protected germplasmDetailsPopupService: GermplasmDetailsPopupService,
                protected inventoryDetailsPopupService: InventoryDetailsPopupService,
                private labelPrintingService: LabelPrintingService,
                private germplasmListManagerContext: GermplasmListManagerContext
    ) {

        this.predicate = '';
        this.routeData = this.activatedRoute.data.subscribe((data) => {
            this.page = data.pagingParams.page;
            this.previousPage = data.pagingParams.page;
            this.reverse = data.pagingParams.ascending;
            this.predicate = data.pagingParams.predicate;
        });
        this.currentSearch = this.activatedRoute.snapshot && this.activatedRoute.snapshot.params['search'] ?
            this.activatedRoute.snapshot.params['search'] : '';

        if (!this.filters) {
            this.filters = GermplasmSearchComponent.getInitialFilters();
            if (!this.principal.hasAnyAuthorityDirect(VIEW_NAMES_PERMISSION)) {
                this.filters = this.filters.filter((filter) => {
                    return !this.NAMES_RELATED_FILTERS.includes(filter.key);
                });
            }
            if (!this.principal.hasAnyAuthorityDirect(VIEW_PEDIGREE_INFORMATION_PERMISSION)) {
                this.filters = this.filters.filter((filter) => {
                    return !this.PEDIGREE_RELATED_FILTERS.includes(filter.key);
                });
            }
            this.eventManager.broadcast({ name: 'reloadFilters', content: { filters: this.filters, request: this.request } });
        }
        this.listBuilderContext.pageSize = this.itemsPerPage;
        this.resultSearch = new SearchResult('');

        this.germplasmService.getGermplasmManagerSettings().toPromise().then((settings) => {
            this.GERMPLASM_MERGE_MAX_SIZE = settings.germplasmMergeLimit;
        });
    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    search(request: GermplasmSearchRequest): Promise<string> {
        return new Promise((resolve, reject) => {
            if (!this.resultSearch.searchResultDbId) {
                this.germplasmService.search(request).subscribe((response) => {
                    this.resultSearch.searchResultDbId = response;
                    resolve(this.resultSearch.searchResultDbId);
                }, (error) => reject(error));
                this.page = 1;
            } else {
                resolve(this.resultSearch.searchResultDbId);
            }
        });
    }

    loadAll(request: GermplasmSearchRequest) {
        this.isLoading = true;
        this.search(request).then((searchId) => {
            this.germplasmService.getSearchResults(
                this.addSortParam({
                    searchRequestId: searchId,
                    page: this.page - 1,
                    size: this.itemsPerPage
                }), this.isBrowseAllResults
            ).pipe(finalize(() => {
                this.isLoading = false;
            })).subscribe(
                (res: HttpResponse<Germplasm[]>) => this.onSuccess(res.body, res.headers)
            );
        });
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate(['./'], {
            queryParamsHandling: 'merge',
            queryParams:
                this.addSortParam({
                    page: this.page,
                    size: this.itemsPerPage,
                    search: this.currentSearch,
                }), relativeTo: this.activatedRoute
        });
        this.loadAll(this.request);
    }

    ngOnInit() {
        this.registerColumnFiltersChanged();
        this.registerFilterBy();
        this.registerGermplasmDetailsChanged();
        this.request.addedColumnsPropertyIds = [];
        this.loadAll(this.request);
        this.hiddenColumns[ColumnLabels['GERMPLASM UUID']] = true;
        this.hiddenColumns[ColumnLabels['GROUP ID']] = true;
        this.hiddenColumns[ColumnLabels['GERMPLASM DATE']] = true;
        this.hiddenColumns[ColumnLabels['METHOD ABBREV']] = true;
        this.hiddenColumns[ColumnLabels['METHOD NUMBER']] = true;
        this.hiddenColumns[ColumnLabels['METHOD GROUP']] = true;
        this.hiddenColumns[ColumnLabels['PREFERRED NAME']] = true;
        this.hiddenColumns[ColumnLabels['PREFERRED ID']] = true;
        this.hiddenColumns[ColumnLabels['GROUP SOURCE GID']] = true;
        this.hiddenColumns[ColumnLabels['GROUP SOURCE']] = true;
        this.hiddenColumns[ColumnLabels['IMMEDIATE SOURCE GID']] = true;
        this.hiddenColumns[ColumnLabels['IMMEDIATE SOURCE']] = true;
        this.hiddenColumns[ColumnLabels['FGID']] = true;
        this.hiddenColumns[ColumnLabels['CROSS-FEMALE PREFERRED NAME']] = true;
        this.hiddenColumns[ColumnLabels['MGID']] = true;
        this.hiddenColumns[ColumnLabels['CROSS-MALE PREFERRED NAME']] = true;
    }

    addSortParam(params) {
        const sort = this.predicate && this.predicate !== SORT_PREDICATE_NONE ? {
            sort: [this.getSort()]
        } : {};
        return Object.assign(params, sort);
    }

    getSort() {
        if (!this.predicate) {
            return '';
        }
        return [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    }

    preSortCheck() {
        const isAddedColumn = this.request.addedColumnsPropertyIds.some((col) => col === this.predicate);
        const isHidden = this.hiddenColumns[this.predicate];
        if (isHidden || !ColumnLabels[this.predicate] && !isAddedColumn) {
            this.clearSort();
        }
    }

    clearSort() {
        this.predicate = SORT_PREDICATE_NONE;
        this.reverse = false;
    }

    onClearSort($event) {
        $event.preventDefault();
        this.clearSort();
        this.transition();
    }

    /**
     * Sorting limits the response size, so it's important to reset
     */
    sort() {
        this.page = 1;
        this.transition();
    }

    trackId(index: number, item: Germplasm) {
        return item.gid;
    }

    registerColumnFiltersChanged() {
        this.subscriptionsManager.add = this.eventManager.subscribe('columnFiltersChanged', (event) => {

            this.preSortCheck();

            if (this.isExpensiveFilter()) {
                const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component);
                confirmModalRef.componentInstance.title = this.translateService.instant('search-germplasm.performance-warning.title');
                let message = this.translateService.instant('search-germplasm.performance-warning.text');
                message += this.getExpensiveFilterWarningList();
                confirmModalRef.componentInstance.message = message;
                confirmModalRef.result.then(() => {
                    this.resetTable();
                }, () => confirmModalRef.dismiss());

            } else {
                this.resetTable();
            }

        });
    }

    registerFilterBy() {
        // E.g germplasm changed via import.
        this.subscriptionsManager.add = this.eventManager.subscribe('filterByGid', (event) => {
            this.resetFilters();
            this.request.gids = event.content;
            this.eventManager.broadcast({ name: 'reloadFilters', content: { filters: this.filters, request: this.request } });
            this.resetTable();
        });
    }

    registerGermplasmDetailsChanged() {
        // E.g germplasm changed via import.
        this.subscriptionsManager.add = this.eventManager.subscribe('germplasmDetailsChanged', (event) => {
            // Reset the germplasm details popup first before reloading the germplasm search table.
            this.germplasmDetailsPopupService.resetPopup().then(() => {
                // Reload the table when a germplasm is updated via germplasm details popup.
                this.transition();
                this.selectedItems = {};
            });
        });
    }

    isExpensiveFilter() {
        return this.request && this.hasNameExpensiveFilters();
    }

    getExpensiveFilterWarningList() {
        let list = '';
        if (this.hasNameExpensiveFilters()) {
            const expensiveFilterMessage = this.translateService.instant('search-germplasm.name-contains-or-ends-with');
            list += `<li>${expensiveFilterMessage}</li>`;
        }
        return list;
    }

    private hasNameExpensiveFilters() {
        return this.request.nameFilter && (this.request.nameFilter.type === MatchType.CONTAINS || this.request.nameFilter.type === MatchType.ENDSWITH)
            || this.request.femaleParentName && (this.request.femaleParentName.type === MatchType.CONTAINS || this.request.femaleParentName.type === MatchType.ENDSWITH)
            || this.request.maleParentName && (this.request.maleParentName.type === MatchType.CONTAINS || this.request.maleParentName.type === MatchType.ENDSWITH)
            || this.request.groupSourceName && (this.request.groupSourceName.type === MatchType.CONTAINS || this.request.groupSourceName.type === MatchType.ENDSWITH)
            || this.request.immediateSourceName && (this.request.immediateSourceName.type === MatchType.CONTAINS || this.request.immediateSourceName.type === MatchType.ENDSWITH);
    }

    hasIncludedGids() {
        return this.request && (
            this.request.includePedigree
            || this.request.includeGroupMembers
        );
    }

    resetTable() {
        this.page = 1;
        this.previousPage = 1;
        this.isSelectAll = false;
        this.selectedItems = {};
        this.loadAll(this.request);
    }

    private getHiddenColumns(selectedColumns): GermplasmColumnModel[] {

        const unselectedColumns: GermplasmColumnModel[] = selectedColumns.filter((column: GermplasmColumnModel) => !column.selected);
        const newHiddenColumns = [];
        unselectedColumns.forEach((column) => {
            newHiddenColumns[ColumnLabels[column.colName]] = true;
        });
        return newHiddenColumns;
    }

    toggleAdditionalColumn(isVisible: boolean, columnPropertyId: string) {
        this.resultSearch.searchResultDbId = '';
        if (isVisible) {
            this.request.addedColumnsPropertyIds.push(columnPropertyId);
        } else {
            this.request.addedColumnsPropertyIds = this.request.addedColumnsPropertyIds.filter((e) => e !== columnPropertyId);
        }
    }

    private onSuccess(data, headers) {
        this.filteredItems = headers.get('X-Filtered-Count');
        this.germplasmList = data;
    }

    private resetFilters() {
        this.filters = GermplasmSearchComponent.getInitialFilters();
        this.request = new GermplasmSearchRequest();
        this.request.addedColumnsPropertyIds = [];
        this.resultSearch = new SearchResult('');
    }

    isSelected(germplasm: Germplasm) {
        return this.selectedItems[germplasm.gid];
    }

    onSelectPage() {
        if (this.isPageSelected()) {
            // remove all items
            this.germplasmList.forEach((g) => delete this.selectedItems[g.gid]);
        } else {
            // check remaining items
            this.germplasmList.forEach((g) => this.selectedItems[g.gid] = g);
        }
    }

    onSelectAll(isSelectAll) {
        this.isSelectAll = !isSelectAll;
        this.selectedItems = {};
    }

    onBrowseAllResults(isBrowseAllResults) {
        if (!isBrowseAllResults) {
            const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component);
            confirmModalRef.componentInstance.title = this.translateService.instant('search-germplasm.browse-all.warning.title');
            const message = this.translateService.instant('search-germplasm.browse-all.warning.message');

            confirmModalRef.componentInstance.message = message;
            confirmModalRef.result.then(() => {
                this.processBrowseAllResults(isBrowseAllResults);
            }, () => {
                this.isBrowseAllResults = false;
                confirmModalRef.dismiss();
            });
        } else {
            this.processBrowseAllResults(isBrowseAllResults);
        }
    }

    processBrowseAllResults(isBrowseAllResults) {
        this.resultSearch = new SearchResult('');
        this.isBrowseAllResults = !isBrowseAllResults;
        this.clearSort();
        this.resetTable();
    }

    toggleSelect($event, index, germplasm: Germplasm, checkbox = false) {
        if (this.isSelectAll) {
            return;
        }
        if (!$event.ctrlKey && !$event.metaKey && !checkbox) {
            this.selectedItems = {};
        }
        let items;
        if ($event.shiftKey) {
            const max = Math.max(this.lastClickIndex, index) + 1,
                min = Math.min(this.lastClickIndex, index);
            items = this.germplasmList.slice(min, max);
        } else {
            items = [germplasm];
            this.lastClickIndex = index;
        }
        const isClickedItemSelected = this.selectedItems[germplasm.gid];
        for (const item of items) {
            if (isClickedItemSelected) {
                delete this.selectedItems[item.gid];
            } else {
                this.selectedItems[item.gid] = item;
            }
        }
    }

    isPageSelected() {
        return this.size(this.selectedItems) && this.germplasmList.every((g) => Boolean(this.selectedItems[g.gid]));
    }

    isSelectAllDisabled() {
        return this.isBrowseAllResults && this.filteredItems > this.SELECT_BROWSE_ALL_RESULTS_MAX_SIZE;
    }

    getSelectAllTooptip() {
        if (this.isSelectAllDisabled()) {
            return this.translateService.instant('search-germplasm.browse-all.warning.filter.required', {
                param: this.SELECT_BROWSE_ALL_RESULTS_MAX_SIZE
            });
        }

        return 'Select all pages';
    }

    size(obj) {
        return Object.keys(obj).length;
    }

    private getSelectedItemIds() {
        return Object.keys(this.selectedItems).map((gid) => Number(gid));
    }

    private validateSelection() {
        if (this.germplasmList.length === 0 || (!this.isSelectAll && this.size(this.selectedItems) === 0)) {
            this.alertService.error('search-germplasm.selection.empty');
            return false;
        }
        return true;
    }

    dragStart($event, dragged: Germplasm) {
        let selected;
        if (this.selectedItems[dragged.gid]) {
            // TODO sort as in table
            selected = Object.values(this.selectedItems).sort((a, b) => a.gid > b.gid ? 1 : -1);
        } else {
            selected = [dragged];
        }
        this.listBuilderContext.data = selected.map((germplasm: Germplasm) => {
            const row: ListEntry = new ListEntry();
            row[ColumnLabels.GID] = germplasm.gid;
            row[ColumnLabels.NAMES] = germplasm.names;
            row[ColumnLabels.AVAILABLE] = germplasm.availableBalance;
            // FIXME consolidate enum ColumnLabels with localization files
            //  Modify backend sorting mechanism if needed
            row['UNIT'] = germplasm.unit;
            row['LOTS'] = germplasm.lotCount;
            row[ColumnLabels.CROSS] = germplasm.pedigreeString;
            row['LOCATION'] = germplasm.locationName;
            row[ColumnLabels['METHOD NAME']] = germplasm.methodName;
            return row;
        });
    }

    dragEnd($event) {
    }

    toggleListBuilder() {
        this.listBuilderContext.visible = !this.listBuilderContext.visible;
    }

    openCreateList() {
        if (!this.validateSelection()) {
            return;
        }

        const searchComposite = new SearchComposite<GermplasmSearchRequest, number>();
        if (this.isSelectAll) {
            searchComposite.searchRequest = this.request;
        } else {
            searchComposite.itemIds = this.getSelectedItemIds();
        }
        this.germplasmManagerContext.searchComposite = searchComposite;

        this.router.navigate(['/', { outlets: { popup: 'germplasm-list-creation-dialog' }, }], {
            replaceUrl: true,
            queryParamsHandling: 'merge'
        });
    }

    openAddToList() {
        if (!this.validateSelection()) {
            return;
        }

        this.addSearchCompositeToContext();

        // Set this.germplasmListManagerContext.activeGermplasmListId to null
        // so that Add To List will use the selected entries from Germplasm Search.
        this.germplasmListManagerContext.activeGermplasmListId = null;

        this.router.navigate(['/', { outlets: { popup: 'germplasm-list-add-dialog' }, }], {
            replaceUrl: true,
            queryParamsHandling: 'merge'
        });
    }

    openCreateLots() {
        if (!this.validateSelection()) {
            return;
        }

        const searchComposite = new SearchComposite<SearchOriginComposite, number>();
        if (this.isSelectAll) {
            searchComposite.searchRequest = new SearchOriginComposite(Number(this.resultSearch.searchResultDbId), SearchOrigin.GERMPLASM_SEARCH);
        } else {
            searchComposite.itemIds = this.getSelectedItemIds();
        }
        this.germplasmManagerContext.searchComposite = searchComposite;

        this.router.navigate(['/', { outlets: { popup: 'lot-creation' }, }], {
            replaceUrl: true,
            queryParamsHandling: 'merge',
            queryParams: {
                searchOrigin: SearchOrigin.GERMPLASM_SEARCH
            }
        });
    }

    private addSearchCompositeToContext() {
        const searchComposite = new SearchComposite<GermplasmSearchRequest, number>();
        if (this.isSelectAll) {
            searchComposite.searchRequest = this.request;
        } else {
            searchComposite.itemIds = this.getSelectedItemIds();
        }
        this.germplasmManagerContext.searchComposite = searchComposite;
    }

    exportDataAndLabels() {
        if (this.germplasmList.length === 0) {
            this.alertService.error('search-germplasm.selection.filter.no.result');
            return;
        }
        const input = {
            selectedGIDs: this.getSelectedItemIds(),
            isBrowseAllGermplasmResults: this.isBrowseAllResults,
            searchRequestId: this.resultSearch.searchResultDbId
        };

        this.labelPrintingService.validateLabelsInfoInputData(input, LabelPrintingType.GERMPLASM).toPromise().then(() => {
            this.router.navigate(['/', 'label-printing-main'], {
                queryParams: {
                    cropName: this.paramContext.cropName,
                    programUUID: this.paramContext.programUUID,
                    printingLabelType: LabelPrintingType.GERMPLASM,
                    openedDirectlyFromNewStudyEditor: false,
                    selectedGIDs: this.getSelectedItemIds(),
                    isBrowseAllGermplasmResults: this.isBrowseAllResults,
                    searchRequestId: this.resultSearch.searchResultDbId
                },
                queryParamsHandling: 'merge',
                onSameUrlNavigation: 'reload'
            }).then(() => {
            });
        });
    }

    openGermplasmCoding() {
        if (!this.validateSelection()) {
            return;
        }
        if (this.isSelectAll) {
            this.alertService.error('germplasm-code.code-all-germplasm-not-supported');
            return;
        }
        if (this.size(this.selectedItems) > 500) {
            this.alertService.error('germplasm-code.too-many-selected-germplasm');
            return;
        }
        const germplasmCodingDialog = this.modalService.open(GermplasmCodingDialogComponent as Component, { size: 'lg', backdrop: 'static' });
        germplasmCodingDialog.componentInstance.gids = this.getSelectedItemIds();
        germplasmCodingDialog.result.then((results) => {
            this.openGermplasmCodingResult(results);
            // Refresh the germplasm search table
            this.transition();
        });
    }

    openGermplasmCodingResult(results: GermplasmCodeNameBatchResultModel[]) {
        if (results) {
            const germplasmCodingResultDialog = this.modalService.open(GermplasmCodingResultDialogComponent as Component, { size: 'lg', backdrop: 'static' });
            germplasmCodingResultDialog.componentInstance.results = results;
        }
    }

    deleteGermplasm() {
        if (!this.validateSelection()) {
            return;
        }

        if (this.isSelectAll) {
            this.alertService.error('germplasm-delete.delete-all-germplasm-not-supported');
            return;
        }

        const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component);
        confirmModalRef.componentInstance.title = this.translateService.instant('germplasm-delete.title');
        confirmModalRef.componentInstance.message = this.translateService.instant('germplasm-delete.message');
        confirmModalRef.result.then(() => {
            this.isLoading = true;
            this.germplasmService.deleteGermplasms(this.getSelectedItemIds()).subscribe((response) => {
                if (response.germplasmWithErrors && response.germplasmWithErrors.length) {
                    this.alertService.warning('germplasm-delete.warning');
                    this.resetFilters();
                    // Show the germplasm that were not deleted because of validation
                    this.request.gids = response.germplasmWithErrors;
                    this.eventManager.broadcast({ name: 'reloadFilters', content: { filters: this.filters, request: this.request } });
                } else {
                    this.alertService.success('germplasm-delete.success');
                }
                this.resetTable();

                // If there are deleted germplasm, show the Clear Prefix Key Cache Sequence Dialog
                if (response.deletedGermplasm && response.deletedGermplasm.length) {
                    this.openKeySequenceDeletionDialog(response.deletedGermplasm);
                }
                this.isLoading = false;
            });
            this.activeModal.close();
        }, () => this.activeModal.dismiss());
    }

    mergeGermplasm() {
        if (this.germplasmList.length === 0 || (!this.isSelectAll && this.size(this.selectedItems) < 2)) {
            this.alertService.error('merge-germplasm.at-least-two-germplasm-are-selected');
            return false;
        }
        if (this.isSelectAll) {
            this.alertService.error('merge-germplasm.merge-all-germplasm-not-supported');
            return;
        }

        if (this.size(this.selectedItems) > Number(this.GERMPLASM_MERGE_MAX_SIZE)) {
            this.alertService.error('merge-germplasm.too-many-selected-germplasm', { param1: this.GERMPLASM_MERGE_MAX_SIZE });
            return;
        }
        const mergeGermplasmModal = this.modalService.open(MergeGermplasmSelectionComponent as Component, { modalDialogClass: 'modal-autofit', backdrop: 'static' });
        mergeGermplasmModal.componentInstance.gids = this.getSelectedItemIds();

    }

    openKeySequenceDeletionDialog(gids: number[]) {
        const confirmModalRef = this.modalService.open(KeySequenceRegisterDeletionDialogComponent as Component);
        confirmModalRef.componentInstance.gids = gids;
    }

    groupGermplasm() {
        if (!this.validateSelection()) {
            return;
        }
        if (this.isSelectAll) {
            this.alertService.error('germplasm-grouping.group-all-germplasm-not-supported');
            return;
        }
        if (this.size(this.selectedItems) > 500) {
            this.alertService.error('germplasm-grouping.too-many-selected-germplasm');
            return;
        }
        const groupGermplasmModal = this.modalService.open(GermplasmGroupOptionsDialogComponent as Component);
        groupGermplasmModal.componentInstance.gids = this.getSelectedItemIds();
        groupGermplasmModal.result.then(((germplasmGroupList) => {
            this.openGermplasmGroupingResult(germplasmGroupList);
        }));
    }

    openGermplasmGroupingResult(results) {
        if (results) {
            const germplasmGroupingResultComponent = this.modalService.open(GermplasmGroupingResultComponent as Component, { size: 'lg', backdrop: 'static' });
            germplasmGroupingResultComponent.componentInstance.results = results;
            germplasmGroupingResultComponent.result.then(() => {
                this.hiddenColumns[ColumnLabels['GROUP ID']] = false;
                this.transition();
            }
            );
        }
    }

    ungroupGermplasm() {
        if (!this.validateSelection()) {
            return;
        }

        if (this.isSelectAll) {
            this.alertService.error('germplasm-grouping.ungroup-all-germplasm-not-supported');
            return;
        }

        const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component, { size: 'lg', backdrop: 'static' });
        confirmModalRef.componentInstance.title = this.translateService.instant('germplasm-grouping.ungrouping.title');
        confirmModalRef.componentInstance.message = this.translateService.instant('germplasm-grouping.ungrouping.message');
        confirmModalRef.result.then(() => {
            this.isLoading = true;
            this.germplasmGroupingService.ungroup(this.getSelectedItemIds()).subscribe((response) => {
                if (response.unfixedGids && response.unfixedGids.length > 0) {
                    if (response.numberOfGermplasmWithoutGroup === 0) {
                        this.alertService.success('germplasm-grouping.ungrouping.success');
                    } else {
                        this.alertService.warning('germplasm-grouping.ungrouping.warning', { param1: response.unfixedGids.length, param2: response.numberOfGermplasmWithoutGroup });
                    }
                    this.hiddenColumns[ColumnLabels['GROUP ID']] = false;
                    this.transition();
                } else {
                    this.alertService.warning('germplasm-grouping.ungrouping.none.successful');
                }
                this.isLoading = false;
            });
            this.activeModal.close();
        }, () => this.activeModal.dismiss());
    }

    showProgenitorNamesColumn() {
        return this.principal.hasAnyAuthorityDirect(VIEW_PEDIGREE_INFORMATION_PERMISSION) && this.principal.hasAnyAuthorityDirect(VIEW_NAMES_PERMISSION);
    }

    showNamesColumn() {
        return this.principal.hasAnyAuthorityDirect(VIEW_NAMES_PERMISSION) && this.germplasmList[0];
    }

    onColumnsSelected(selectedColumns) {
        this.hiddenColumns = this.getHiddenColumns(selectedColumns);
        let hasAddedColumns = false;
        this.request.addedColumnsPropertyIds = [];

        // toggle additional columns
        selectedColumns.forEach((column) => {
            const columnName = column.colName;
            if (this.additionalColumns.includes(columnName)) {
                this.toggleAdditionalColumn(!this.hiddenColumns[ColumnLabels[columnName]], ColumnLabels[columnName]);
                hasAddedColumns = true;
            }
        });

        if (hasAddedColumns) {
            this.preSortCheck();
            this.resetTable();
        }
    }

    protected readonly preventDefaultOnShiftKey = preventDefaultOnShiftKey;
}

export enum ColumnLabels {
    'GID' = 'GID',
    'GERMPLASM UUID' = 'GERMPLASM UUID',
    'GROUP ID' = 'GROUP ID',
    'NAMES' = 'NAMES',
    'AVAILABLE' = 'AVAILABLE',
    'LOT_UNITS' = 'LOT_UNITS',
    'LOTS' = 'LOTS',
    'CROSS' = 'CROSS',
    'PREFERRED ID' = 'PREFERRED ID',
    'PREFERRED NAME' = 'PREFERRED NAME',
    'GERMPLASM DATE' = 'GERMPLASM DATE',
    'LOCATIONS' = 'LOCATIONS',
    'METHOD NAME' = 'METHOD NAME',
    'METHOD ABBREV' = 'METHOD ABBREV',
    'METHOD NUMBER' = 'METHOD NUMBER',
    'METHOD GROUP' = 'METHOD GROUP',
    'FGID' = 'FGID',
    'CROSS-FEMALE PREFERRED NAME' = 'CROSS-FEMALE PREFERRED NAME',
    'MGID' = 'MGID',
    'CROSS-MALE PREFERRED NAME' = 'CROSS-MALE PREFERRED NAME',
    'GROUP SOURCE GID' = 'GROUP SOURCE GID',
    'GROUP SOURCE' = 'GROUP SOURCE',
    'IMMEDIATE SOURCE GID' = 'IMMEDIATE SOURCE GID',
    'IMMEDIATE SOURCE' = 'IMMEDIATE SOURCE',
}
